module.exports = __webpack_public_path__ + "img/photo_2023-11-19 17.44.01.558f3247.jpg";